import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsAureliaComponent } from './simple-icons-aurelia.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsAureliaComponent ],
    exports:      [ SimpleIconsAureliaComponent ],
    bootstrap:    []
})
export class SimpleIconsAureliaModule {}
